import * as React from 'react';
import { Button, Input, Modal, ProgressIndicator } from '@salesforce/design-system-react';
import { MatchingRule } from 'lib/types';
import { Grid, Col } from 'lib/grid';
import bodySvg from './modal-1-body.svg';

interface EditModalProps {
	onClose: () => void;
	onNext: () => void;
	rule: MatchingRule;
}

const steps = [{id: 1, label: 'Edit Matching Rule'}, {id: 2, label: 'Preview Matching Rule'}];

const EditModal: React.SFC<EditModalProps> = ({ onClose, onNext, rule }) => (
	<Modal
		containerClassName={['matching-rules_modal1']}
		footer={[
			<Button className="slds-float_left" key="a" label="Cancel" />,
			<ProgressIndicator className="slds-float_left slds-progress_shade" key="b" steps={steps} selectedStep={steps[0]} />,
			<Button key="c" label="Next" onClick={onNext} variant="brand" />
		]}
		isOpen={true}
		onRequestClose={onClose}
		size="large"
		title="Edit Matching Rule"
	>
		<div className="slds-m-horizontal_medium">
			<h2 className="slds-text-heading_small slds-m-bottom_small slds-m-top_small">
				<strong>Rule Information</strong>
			</h2>
			<Grid className="slds-gutters">
				<Col size="1-of-4">
					<Input id="name" label="Name" required value={rule.name} />
				</Col>
				<Col size="2-of-4">
					<Input id="description" label="Description" value={rule.description} />
				</Col>
			</Grid>
		</div>
		<hr className="slds-m-vertical_medium" />
		<div className="slds-m-right_medium slds-m-bottom_medium">
			<h2 className="slds-text-heading_small slds-m-bottom_small slds-m-left_medium">
				<strong>Matching Criteria</strong>
			</h2>
			<object data={bodySvg} width="1134" height="302" />
		</div>
	</Modal>
);

export default EditModal;



// WEBPACK FOOTER //
// ./src/MatchingRules/edit-modal-1.tsx